<template>
  <div v-if="getShow" id="loadingEditor">
    <div class="spinner">
      <div class="dot1"></div>
      <div class="dot2"></div>
    </div>
  </div>
</template>
<script>
import { useChangeOptionsStore } from "@/stores/modules/changeOptions";
import { mapState, mapActions } from "pinia";

export default {
  computed: { ...mapState(useChangeOptionsStore, ["getShow"]) },
  methods: {}
};
</script>
